/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Friend_Code_DescriptionInputs */

const en_mobile_referral_friend_code_description = /** @type {(inputs: Mobile_Referral_Friend_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a friend invited you, enter their code here.`)
};

const es_mobile_referral_friend_code_description = /** @type {(inputs: Mobile_Referral_Friend_Code_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si un amigo te invitó, ingresa su código aquí.`)
};

/**
* | output |
* | --- |
* | "If a friend invited you, enter their code here." |
*
* @param {Mobile_Referral_Friend_Code_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_friend_code_description = /** @type {((inputs?: Mobile_Referral_Friend_Code_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Friend_Code_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_friend_code_description(inputs)
	return en_mobile_referral_friend_code_description(inputs)
});